<template>
  <div class="way-container">
    <!-- 应急措施 -->
    <div class="hearder-title">
      <div class="flex_between">
        <!-- <img class="title-icon" src="@/assets/img/title-icon.svg" alt="dark" /> -->
        {{ $t("zlfk.yjcs") }}
      </div>
    </div>
    <el-form :inline="true" :label-width="labelWidth" :model="form" :rules="rules" ref="form">
      <div class="form-container">
        <!-- 应急措施市场话术中文 -->
        <div>
          <el-form-item :label="$t('zlfk.yjcszw')+':'">
            <el-input
              :disabled="true"
              v-model="form.marketLanguageVal"
              type="textarea"
              style="width: 670px"
              :autosize="{ minRows: 4, maxRows: 4 }"
            />
          </el-form-item>
          <el-form-item>
            <translate-btn
              style="margin-top: 30px; padding-left: 10px"
              :content="form.marketLanguage"
              field="marketLanguageVal"
              :disabledLeft="true"
              @getTranslateVal="
                (field, value) => {
                  this.$set(this.form, field, value);
                }
              "
            />
          </el-form-item>
        </div>
        <!-- 应急措施市场话术英文 -->
        <div>
          <el-form-item :label="$t('zlfk.yjcsyw')+':'">
            <el-input
              :disabled="true"
              v-model="form.marketLanguageEn"
              type="textarea"
              style="width: 670px"
              :autosize="{ minRows: 4, maxRows: 4 }"
            />
          </el-form-item>
        </div>
        <!-- 附件 -->
        <div>
          <el-form-item :label="$t('zlfk.fj')+':'">
            <upload-file
              :disabled="true"
              action=""
              v-model="form.emergencyMeasureFileList"
            >
              <div>
                <p>{{ $t("zlfk.scsm") }}</p>
                <p>{{ $t("zlfk.tpzc") }}</p>
                <p>{{ $t("zlfk.spzc") }}</p>
                <p>{{ $t("zlfk.wdzc") }}</p>
              </div>
            </upload-file>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
// import UploadFile from "@/components/uploadFile2.vue";
import UploadFile from "@/components/uploadNew.vue";
import TranslateBtn from "@/components/translateBtn.vue";

export default {
  components: { UploadFile, TranslateBtn },
  props: {
    problemData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.getForm(), // 问题详情
      rules: {},
    };
  },
  computed: {
    labelWidth() {
      const widthMap = {
        "zh": "130px",
        "ru": "350px",
        "en": "245px",
        "vi": "245px",
        "es": "240px",
        "fa": "200px"
      };
      return widthMap[this.$i18n.locale] || "210px";
    },
  },
  methods: {
    getForm() {
      return {
        ...JSON.parse(JSON.stringify(this.problemData)),
        marketLanguageVal: this.problemData.marketLanguage || "",
        emergencyMeasureFileList: this.problemData.emergencyMeasureFileList || [],
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.way-container {
  padding-bottom: 20px;
  ::v-deep .el-input {
    width: 250px;
  }
  // .hearder-title {
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  //   font-size: 14px;
  //   color: #333333;
  //   padding: 14px 10px 14px 20px;
  //   border-bottom: 1px solid #dcdee0;
  //   .title-icon {
  //     margin-right: 10px;
  //   }
  //   p {
  //     font-size: 16px;
  //     color: #bd3124;
  //     font-weight: bold;
  //     i {
  //       font-size: 18px;
  //       color: #bd3124;
  //       display: inline-block;
  //       margin-right: 5px;
  //     }
  //   }
  // }
  .form-container {
    margin-top: 34px;
    padding: 0 60px;
    .number-input {
      // width: 250px;
      ::v-deep .el-input__inner {
        // text-align: left;
      }
    }
    .number-input-append {
      // color: #666666;
      // background: #efefef;
      // border-radius: 0 4px 4px 0;
      // display: inline-block;
      // height: 38px;
      // line-height: 38px;
      // padding: 0 15px;
      // text-align: center;
      // position: absolute;
      // right: 1px;
      // top: 50%;
      // transform: translateY(-50%);
    }
  }
}
</style>
